import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "home-top-wrap flex" }
const _hoisted_2 = { class: "menu-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "menu-name" }
const _hoisted_5 = {
  key: 0,
  class: "badge-wrap"
}
const _hoisted_6 = {
  key: 1,
  class: "badge-wrap"
}
const _hoisted_7 = {
  key: 2,
  class: "badge-wrap"
}
const _hoisted_8 = { class: "user-avatar-wrap" }
const _hoisted_9 = { class: "avatar-inner-wrap" }
const _hoisted_10 = { class: "user-info-row flex" }
const _hoisted_11 = { class: "user-info-label" }
const _hoisted_12 = { class: "user-info-box" }
const _hoisted_13 = { class: "user-info-row flex" }
const _hoisted_14 = { class: "user-info-label" }
const _hoisted_15 = { class: "user-info-box" }
const _hoisted_16 = { class: "user-info-value" }
const _hoisted_17 = { class: "user-info-row flex" }
const _hoisted_18 = { class: "user-info-label" }
const _hoisted_19 = { class: "user-info-box" }
const _hoisted_20 = { class: "user-info-value" }
const _hoisted_21 = { class: "user-info-row flex" }
const _hoisted_22 = { class: "user-info-label" }
const _hoisted_23 = { class: "user-info-box" }
const _hoisted_24 = { class: "user-info-value" }
const _hoisted_25 = { class: "menu-wrap" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "menu-name" }
const _hoisted_28 = {
  key: 0,
  class: "badge-wrap"
}
const _hoisted_29 = {
  key: 1,
  class: "badge-wrap"
}
const _hoisted_30 = {
  key: 2,
  class: "badge-wrap"
}

import { ref, reactive } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useHelpTool } from '@/hooks';
import { useUserStore, useReddotStore } from '@/store';
import BindMobile from '@/view/user/components/BindMobile.vue';
import BindSuperior from '@/view/user/components/BindSuperior.vue';
import SelectAvatar from '@/view/user/components/SelectAvatar.vue';


export default {
  __name: 'HomeTop',
  setup(__props) {

const router = useRouter();
const { doShare, copy } = useHelpTool()
const userStore = useUserStore()
const { uid, username, nickname, phone, avatar, invitationCode, registrationCode } = storeToRefs(userStore);
const redDotStore = useReddotStore();
const { loginBonusRewardNum, inboxUnread, taskRewardNum } = storeToRefs(redDotStore);

const leftMenuList = reactive([
  { code: 'signUpBonus',  pathName: 'signUp' },
  { code: 'task',  pathName: 'task' },
  { code: 'share',  onClick: doShare },
]);

const rightMenuList = reactive([
  { code: 'inbox',  pathName: 'inbox' },
  { code: 'vip',  pathName: 'vip' },
  { code: 'security',  pathName: 'securityCenter' },
])

const showInfo = ref(false);
const editNickname = ref(false)
const _nickname = ref('')
const nicknameRef = ref()
const showBindMobile = ref(false)
const showBindSuperior = ref(false)
const showSelectAvatar = ref(false)

const clickMenu = item => {
  if(item.onClick) {
    item.onClick()
  } else {
    router.push({ name: item.pathName })
  }
}

const doEditNickname = () => {
  if(!editNickname.value) {
    editNickname.value = true;
    _nickname.value = nickname.value;
    setTimeout(() => {
      nicknameRef.value.focus()
    }, 0)
  } else {
    if (_nickname.value) {
      editNickname.value = false;
      userStore.modifyUserInfo({ nickname: _nickname.value })
    }
  }
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_field = _resolveComponent("van-field")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftMenuList, (item) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "menu-item",
          key: item.code,
          onClick: $event => (clickMenu(item))
        }, [
          _createVNode(_component_van_image, {
            class: "menu-icon",
            fit: "contain",
            src: require(`@/assets/img/home/menu/${item.code}.png`)
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`menu.${item.code}`).toUpperCase()), 1),
          (item.code === 'inbox' && _unref(inboxUnread))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(inboxUnread)), 1))
            : (item.code === 'signUpBonus' && _unref(loginBonusRewardNum))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(loginBonusRewardNum)), 1))
              : (item.code === 'task' && _unref(taskRewardNum))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(taskRewardNum)), 1))
                : _createCommentVNode("", true)
        ], 8, _hoisted_3)), [
          [_directive_audio]
        ])
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["avatar-image-wrap", {'show-info': showInfo.value }])
        }, [
          _createVNode(_component_van_image, {
            class: "avatar-image",
            fit: "cover",
            src: _unref(avatar) || require('@/assets/img/common/logo.png')
          }, null, 8, ["src"]),
          (_unref(uid))
            ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                key: 0,
                class: "eidt-icon",
                fit: "contain",
                src: require('@/assets/img/home/edit.png'),
                onClick: _cache[0] || (_cache[0] = $event => (showSelectAvatar.value = true))
              }, null, 8, ["src"])), [
                [_directive_audio]
              ])
            : _createCommentVNode("", true)
        ], 2),
        (_unref(uid))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["user-info-wrap", {'show-info': showInfo.value }])
            }, [
              _withDirectives(_createVNode(_component_van_image, {
                class: "triangle-icon",
                src: require('@/assets/img/home/triangle.png'),
                onClick: _cache[1] || (_cache[1] = $event => (showInfo.value = !showInfo.value))
              }, null, 8, ["src"]), [
                [_directive_audio]
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('label.name')) + ":", 1),
                _createElementVNode("div", _hoisted_12, [
                  _withDirectives(_createElementVNode("div", { class: "user-info-value" }, _toDisplayString(_unref(nickname) || _unref(username)), 513), [
                    [_vShow, !editNickname.value]
                  ]),
                  _withDirectives(_createVNode(_component_van_field, {
                    ref_key: "nicknameRef",
                    ref: nicknameRef,
                    class: "user-info-value",
                    maxlength: "12",
                    modelValue: _nickname.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_nickname).value = $event))
                  }, null, 8, ["modelValue"]), [
                    [_vShow, editNickname.value]
                  ]),
                  (!editNickname.value)
                    ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                        key: 0,
                        class: "action-icon",
                        fit: "contain",
                        src: require('@/assets/img/common/edit.png'),
                        onClick: doEditNickname
                      }, null, 8, ["src"])), [
                        [_directive_audio]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: doEditNickname
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.ok').toUpperCase()), 1)
                      ])), [
                        [_directive_audio]
                      ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('label.userId')) + ":", 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(invitationCode)), 1),
                  _withDirectives(_createVNode(_component_van_image, {
                    class: "action-icon",
                    fit: "contain",
                    src: require('@/assets/img/common/copy.png'),
                    onClick: _cache[3] || (_cache[3] = $event => (_unref(copy)(_unref(invitationCode))))
                  }, null, 8, ["src"]), [
                    [_directive_audio]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('label.mobilePhone')) + ":", 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(phone)), 1),
                  (!_unref(phone))
                    ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                        key: 0,
                        class: "action-icon",
                        fit: "contain",
                        src: require('@/assets/img/common/edit.png'),
                        onClick: _cache[4] || (_cache[4] = $event => (showBindMobile.value = true))
                      }, null, 8, ["src"])), [
                        [_directive_audio]
                      ])
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('label.superior')) + ":", 1),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(registrationCode)), 1),
                  (!_unref(registrationCode))
                    ? _withDirectives((_openBlock(), _createBlock(_component_van_image, {
                        key: 0,
                        class: "action-icon",
                        fit: "contain",
                        src: require('@/assets/img/common/edit-user.png'),
                        onClick: _cache[5] || (_cache[5] = $event => (showBindSuperior.value = true))
                      }, null, 8, ["src"])), [
                        [_directive_audio]
                      ])
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_van_image, {
        class: "avatar-border",
        src: require('@/assets/img/home/avatar-border.png')
      }, null, 8, ["src"]),
      _createVNode(_component_van_image, {
        class: "logo-title",
        src: require('@/assets/img/common/logo-title.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_25, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightMenuList, (item) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "menu-item",
          key: item.code,
          onClick: $event => (clickMenu(item))
        }, [
          _createVNode(_component_van_image, {
            class: "menu-icon",
            fit: "contain",
            src: require(`@/assets/img/home/menu/${item.code}.png`)
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t(`menu.${item.code}`).toUpperCase()), 1),
          (item.code === 'inbox' && _unref(inboxUnread))
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(inboxUnread)), 1))
            : (item.code === 'signUpBonus' && _unref(loginBonusRewardNum))
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(loginBonusRewardNum)), 1))
              : (item.code === 'task' && _unref(taskRewardNum))
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(taskRewardNum)), 1))
                : _createCommentVNode("", true)
        ], 8, _hoisted_26)), [
          [_directive_audio]
        ])
      }), 128))
    ]),
    (showBindMobile.value)
      ? (_openBlock(), _createBlock(BindMobile, {
          key: 0,
          onOnClose: _cache[6] || (_cache[6] = $event => (showBindMobile.value = false))
        }))
      : _createCommentVNode("", true),
    (showBindSuperior.value)
      ? (_openBlock(), _createBlock(BindSuperior, {
          key: 1,
          onOnClose: _cache[7] || (_cache[7] = $event => (showBindSuperior.value = false))
        }))
      : _createCommentVNode("", true),
    (showSelectAvatar.value)
      ? (_openBlock(), _createBlock(SelectAvatar, {
          key: 2,
          onOnClose: _cache[8] || (_cache[8] = $event => (showSelectAvatar.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

}